<template>
  <section class="search-query">
    <label class="mb-3">{{ label }}</label>
    <b-card class="search-card">
      <b-textarea v-model="clipboardText" v-if="isCopyToClipboard" ref="clipboardRef"></b-textarea>
      <b-container fluid v-if="!isCopyToClipboard">
        <b-row align-h="center" class="mt-2 ml-2 mr-1">
          <b-col>
            <label class="duplicate-label" v-if="duplicateQueries">дубликат</label>
            <label v-if="upMaxLength">лимит 35 символов превышен для запросов с разделением "|"</label>
            <b-textarea
                size="sm"
                class="mb-2 query-input"
                rows="1"
                v-model="newQueries"
                v-on:change="addNewQuery"
                placeholder="Введите запрос"
                v-on:input="inputProcessing"
            >
            </b-textarea>
            <button type="button" class="but-add-queries but-remove close b-form-tag-remove ml-1">+</button>
          </b-col>
        </b-row>
        <b-row v-for="ruQuery in reSortSearchQueries" v-bind:key="ruQuery.id">
          <b-col class="search-name-box">
            <b-container fluid>
              <b-row>
                <b-col cols="11" class="text-left">
                  <i
                      v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                      v-on:click="editQueries(ruQuery.id)"
                  >{{ ruQuery.query }}</i>
                  <b-input
                      v-model="editingSearchQuery"
                      v-show="isEditQueries[ruQuery.id] != undefined && isEditQueries[ruQuery.id]"
                      v-on:change="editQueries(ruQuery.id, true)"
                      :ref="'editQueries_'+ ruQuery.id"
                      size="sm"
                      class="mb-1"
                      v-if="getSearchQueriesVal(ruQuery.id) != undefined"
                      v-on:focusout="handleFocusout(ruQuery.id)"
                      v-on:input="inputProcessingEdit(ruQuery.id)"
                  ></b-input>
                  <label v-if="duplicateQueriesEdit[ruQuery.id]">дубликат</label>
                  <label v-if="upMaxLengthEdit[ruQuery.id]">лимит 35 превышен</label>
                </b-col>
                <b-col cols="1">
                  <button type="button" class="but-remove close b-form-tag-remove ml-1"
                          v-on:click="queryDelete(ruQuery.id)">×
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </section>
</template>

<script>
export default {
  name: "SearchQuery",
  props: {
    searchQueries: Array,
    label: String,
    change: Function,
    existPhrase: Boolean,
  },
  data() {
    return {
      isEditQueries: {},
      newQueries: null,
      duplicateQueries: false,
      clipboardText: '',
      isCopyToClipboard: false,
      upMaxLength: false,
      duplicateQueriesEdit: {},
      upMaxLengthEdit: {},
      editingSearchQuery: null
    }
  },
  methods: {
    getSearchQueriesVal: function (id) {
      for (let key in this.searchQueries) {
        if (this.searchQueries[key].id === id) {
          return this.searchQueries[key]
        }
      }
    },
    getMaxKey: function (object) {
      let maxKey = -1;
      for (let key in object) {
        if (parseInt(object[key].id) > maxKey) {
          maxKey = object[key].id;
        }
      }
      return maxKey;
    },
    addNewQuery: function () {
      this.duplicateClear(this.newQueries)
      if (this.duplicateCheck(this.newQueries)) {
        return false;
      }

      let maxKey = this.getMaxKey(this.searchQueries);
      maxKey++;
      let newKey = maxKey;
      let queriesSplit = this.newQueries.split("\n");
      queriesSplit.forEach((val) => {
        if (val && val.trim() != '') {
          let tabSplit = val.split("\t");
          this.searchQueries.push({
            id: newKey,
            query: tabSplit[0],
            isNew: true,
          });
          newKey++;
        }
      });
      this.newQueries = null;
      if (queriesSplit.length > 0 && queriesSplit[0] != "") {
        this.change();
      }
    },
    editQueries: function (id, isStop = false) {
      if (!isStop) {
        this.editingSearchQuery = this.getSearchQueriesVal(id).query
      }
      if (
          this.duplicateCheck(this.editingSearchQuery, id)
      ) {
        return false;
      }

      for (let key in this.isEditQueries) {
        this.$set(this.isEditQueries, key, false);
      }

      this.$set(this.isEditQueries, id, !isStop);
      this.$nextTick(() => {
        if (isStop) {
          this.change();
        }
        this.$refs['editQueries_' + id][0].focus();
      });
    },
    queryDelete: async function (id) {
      for (let key in this.searchQueries) {
        if (this.searchQueries[key].id === id) {
          this.searchQueries.splice(key, 1);
          this.$forceUpdate();
        }
      }
      this.change();
    },
    duplicateCheck: function (query, id = false) {
      let queriesSplit = query.split("\n");
      // self check
      for (let qKey1 in queriesSplit) {
        for (let qKey2 in queriesSplit) {
          let tabSplit1 = queriesSplit[qKey1].split("\t");
          let tabSplit2 = queriesSplit[qKey2].split("\t");
          if (tabSplit1[0] != '' && tabSplit1[0] == tabSplit2[0] && qKey1 != qKey2) {
            this.duplicateQueries = true;
            return true;
          }
        }
      }
      // exist check
      for (let qKey in queriesSplit) {
        let tabSplit = queriesSplit[qKey].split("\t");
        for (let key in this.searchQueries) {
          if (tabSplit[0] != '' && id !== this.searchQueries[key].id && tabSplit[0] == this.searchQueries[key].query) {
            if (id) {
              this.duplicateQueriesEdit[id] = true;
            } else {
              this.duplicateQueries = true;
            }
            return true;
          } else {
            if (id) {
              this.duplicateQueriesEdit[this.searchQueries[key].id] = false;
            }
          }
        }
      }
      this.duplicateQueries = false;
      return false;
    },

    duplicateClear: function (query, id = false) {
      let queriesSplit = query.split("\n");
      // self check
      for (let qKey1 in queriesSplit) {
        for (let qKey2 in queriesSplit) {
          let tabSplit1 = queriesSplit[qKey1].split("\t");
          let tabSplit2 = queriesSplit[qKey2].split("\t");
          if ((tabSplit1[0] == tabSplit2[0] && qKey1 != qKey2)) {
              // remove duplicate
              queriesSplit.splice(qKey2, 1)
          }
        }
      }
      // for existed
      for (let qKey in queriesSplit) {
        let tabSplit = queriesSplit[qKey].split("\t");
        for (let key in this.searchQueries) {
          if (id !== this.searchQueries[key].id && tabSplit[0] == this.searchQueries[key].query) {
            queriesSplit.splice(qKey, 1)
            this.duplicateClear(queriesSplit.join("\n"), id)
            return
          }
        }
      }
      // save clearing text
      this.newQueries = queriesSplit.join("\n")
    },

    inputProcessing: function () {
      this.duplicateCheck(this.newQueries);
    },
    inputProcessingEdit: function (id) {
      this.duplicateCheck(this.getSearchQueriesVal(id)['query'], id);
      this.getSearchQueriesVal(id)['query'] = this.editingSearchQuery
    },

    handleFocusout: function (id) {
      if (
          !this.duplicateCheck(this.getSearchQueriesVal(id)['query'], id)
      ) {
        this.getSearchQueriesVal(id)['query'] = this.editingSearchQuery
        this.isEditQueries[id] = false
      } else {
        this.$nextTick(() => {
          this.$refs['editQueries_' + id][0].focus();
        });
        return false;
      }
    },
    reSort: function () {
      this.searchQueries.sort((a, b) => { return a.id < b.id ? 1 : -1})
    }
  },
  computed: {
    reSortSearchQueries() {
      this.reSort()
      return this.searchQueries
    }
  },
  mounted() {
  },
  created() {
  },
  watch: {
  }
}
</script>

<style scoped>
.search-link-box.col-4 {
  flex: 0 0 30%;
  max-width: 30%;
}

.search-name-box.col-8 {
  flex: 0 0 70%;
  max-width: 70%;
}

.search-query button.but-remove:focus {
  outline: none;
}

/*.query-aria::-webkit-scrollbar {*/
/*    display: none;*/
/*}*/
/*.query-aria {*/
/*    -ms-overflow-style: none;  !* IE and Edge *!*/
/*    scrollbar-width: none;  !* Firefox *!*/
/*}*/

.search-query .query-input {
  height: 34px;
  width: 91%;
  margin-right: 5px;
  display: inline-block;
}

.but-add-queries {
  line-height: 34px;
}

.box-but-copy {
  text-align: right;
  margin-top: -8px;
  padding-right: 2px;
  margin-right: -9px;
  margin-bottom: 13px;
  position: sticky;
  top: 10px;
  z-index: 999;
  background: white;
  padding-top: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid;
}

.but-copy {
  float: right;
  margin-bottom: 5px;
}

label {
  text-align: left;
  margin: 0;
  float: left;
}

.search-card {
  width: 100%;
  overflow-y: auto;
}

.duplicate-label {
  margin-right: 10px;
  color: red;
}
</style>